module.exports = __webpack_public_path__ + "img/etc_active.b4c91fa7.svg";